'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _join = require('../../common/join');

var _join2 = _interopRequireDefault(_join);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var Expander = function Expander(_ref) {
  var className = _ref.className,
      rootClassName = _ref.rootClassName,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 20 : _ref$size,
      onClick = _ref.onClick,
      fill = _ref.fill,
      rtl = _ref.rtl;

  return _react2.default.createElement(
    'svg',
    {
      className: (0, _join2.default)(className, rootClassName + '__expander'),
      onClick: onClick,
      fill: fill,
      height: size,
      width: size,
      viewBox: '0 0 24 24'
    },
    rtl ? _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' }) : _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' })
  );
};

Expander.isExpander = true;

exports.default = Expander;